/**
 * お問い合わせページに表示する期間限定お知らせの設定
 */
import isWithinRange from "date-fns/is_within_range";

type LocalizedText = {
  ja: string;
  en: string;
  ko: string;
  "zh-CN": string;
  "zh-TW": string;
};

export interface ContactNotice {
  title: LocalizedText;
  message: LocalizedText;
  startAt: Date;
  endAt: Date;
}

/**
 * 年末年始お知らせ設定
 */
export const yearEndNotice: ContactNotice = {
  title: {
    ja: "年末年始期間中のお問い合わせ対応につきまして",
    en: "Notice Regarding Inquiry Support During Year-End and New Year Period",
    ko: "연말연시 기간 중 문의 대응에 관하여",
    "zh-CN": "关于年末年初期间咨询回复的通知",
    "zh-TW": "關於年末年初期間諮詢回覆的通知",
  },
  message: {
    ja: "2025年12月27日(土)〜2026年1月4日(日)の間、お問い合わせへの回答にお時間をいただく場合がございます（1月5日以降、順次回答）。",
    en: "Responses to inquiries may take longer than usual from Saturday, December 27, 2025, to Sunday, January 4, 2026 (responses will be provided sequentially from January 5 onwards).",
    ko: "2025년 12월 27일(토)~2026년 1월 4일(일) 기간 동안 문의 답변에 시간이 걸릴 수 있습니다(1월 5일 이후 순차적으로 답변).",
    "zh-CN": "2025年12月27日(六)至2026年1月4日(日)期间，咨询回复可能需要更长时间（1月5日起陆续回复）。",
    "zh-TW": "2025年12月27日(六)至2026年1月4日(日)期間，諮詢回覆可能需要更長時間（1月5日起陸續回覆）。",
  },
  startAt: new Date("2025-12-10T00:00:00+09:00"),
  endAt: new Date("2026-01-07T23:59:59+09:00"),
};

/**
 * 現在表示すべきお知らせを取得する
 */
export const getActiveContactNotice = (): ContactNotice | null => {
  const now = new Date();

  if (isWithinRange(now, yearEndNotice.startAt, yearEndNotice.endAt)) {
    return yearEndNotice;
  }

  return null;
};
